var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.9105 6.55651C16.7019 6.34794 16.3649 6.34794 16.1564 6.55651C15.9479 6.76502 15.9479 7.10215 16.1564 7.31066L18.2896 9.44403C18.3936 9.54804 18.5302 9.60029 18.6667 9.60029C18.8033 9.60029 18.9398 9.54804 19.0438 9.44403C19.2522 9.23547 19.2522 8.89839 19.0438 8.68989L16.9105 6.55651Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.7113 7.62316C13.5028 7.41459 13.1657 7.41459 12.9572 7.62316C12.7487 7.83173 12.7486 8.1688 12.9572 8.37731L17.2238 12.6441C17.3278 12.7481 17.4643 12.8004 17.6008 12.8004C17.7374 12.8004 17.8739 12.7481 17.9779 12.6441C18.1864 12.4356 18.1864 12.0985 17.9779 11.89L13.7113 7.62316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.9046 20.6433L25.2757 23.0146C25.3797 23.1191 25.5163 23.1708 25.6528 23.1708C25.7888 23.1708 25.9253 23.1191 26.0298 23.0146C26.2378 22.8065 26.2378 22.4689 26.0298 22.2604L23.5323 19.7627C24.8373 17.7568 25.5994 15.3668 25.5994 12.8004C25.5994 5.74254 19.8572 0 12.7997 0C5.7422 0 0 5.74261 0 12.8004C0 19.8583 5.74226 25.6008 12.7997 25.6008C16.9037 25.6008 20.5606 23.6568 22.9046 20.6433ZM12.7997 24.5341C6.33 24.5341 1.06667 19.2705 1.06667 12.8004C1.06667 6.33037 6.33 1.06672 12.7997 1.06672C19.2695 1.06672 24.5328 6.33031 24.5328 12.8004C24.5328 19.2704 19.2695 24.5341 12.7997 24.5341Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.7993 2.13342C6.91778 2.13342 2.13281 6.91863 2.13281 12.8004C2.13281 18.6822 6.91778 23.4674 12.7993 23.4674C18.6808 23.4674 23.4658 18.6822 23.4658 12.8004C23.4658 6.91856 18.6808 2.13342 12.7993 2.13342ZM12.7993 22.4007C7.50608 22.4007 3.19948 18.0939 3.19948 12.8004C3.19948 7.50696 7.50608 3.20014 12.7993 3.20014C18.0925 3.20014 22.3991 7.50696 22.3991 12.8004C22.3991 18.0939 18.0925 22.4007 12.7993 22.4007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M31.2191 27.4488L27.4816 23.7117C27.3818 23.6114 27.2464 23.5554 27.1045 23.5554H27.104C26.9627 23.5554 26.8267 23.612 26.7264 23.7127L25.2224 25.2248C25.0144 25.4338 25.0155 25.7709 25.2246 25.9789C25.4336 26.1869 25.7712 26.1864 25.9787 25.9768L27.1056 24.844L30.465 28.203C30.7668 28.5054 30.9338 28.907 30.9338 29.3348C30.9338 29.7615 30.7668 30.1636 30.465 30.4655C29.8415 31.089 28.8271 31.09 28.2026 30.4661L21.8828 24.1459C21.6748 23.9379 21.3371 23.9379 21.1287 24.1459C20.9207 24.3544 20.9207 24.692 21.1287 24.9006L27.4485 31.2202C27.968 31.7402 28.6506 32 29.3333 32C30.016 32 30.6996 31.7397 31.2191 31.2202C31.7226 30.7161 32.0004 30.0467 32.0004 29.3347C32.0004 28.6222 31.7226 27.9523 31.2191 27.4488Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudit);
export default __webpack_public_path__ + "static/media/Audit.23962b1391da7342ebc66db47e439374.svg";
export { ForwardRef as ReactComponent };